<template>
  <v-dialog persistent v-model="walletHistoryDialog" width="700" scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2"
        >Wallet history</v-card-title
      >

      <v-card-text class="pt-3 p-0">
        <h5>This displays current wallet information of the Doctor.</h5>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3 bg-light-2 rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img src="/img/avatars/income.svg" alt="Added" class="pa-1" />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.added.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Points added</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3 bg-light-blue rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img
                    src="/img/avatars/get-money.svg"
                    alt="Balance"
                    class="pa-1"
                  />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.balance.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Balance</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3 bg-light rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img src="/img/avatars/rupee.svg" alt="Redeem" class="pa-1" />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.redeemed.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Redeemed</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3 bg-success-light rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img
                    src="/img/avatars/increase.svg"
                    alt="Utilize"
                    class="pa-1"
                  />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.used.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Utilize</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3 bg-light rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img
                    src="/img/avatars/referral-point.svg"
                    alt="Referral points"
                    class="pa-1"
                  />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.referal_balance.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Referral points</p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="counts d-flex align-center py-4 px-3  bg-error--text-light rounded-lg flex-grow-1 h-100"
              >
                <v-avatar size="40" class="bg-white">
                  <img src="/img/avatars/point.svg" alt="Redeem" class="pa-1" />
                </v-avatar>
                <div class="ml-3">
                  <p
                    class="text-no-wrap my-0 font-weight-bold subtitle-font line-height-1"
                  >
                    {{walletHistory.redeemable.toFixed(2)}}
                  </p>
                  <p class="p-color my-0">Redeemable balance</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import config from "@/config.js";
export default {
  props: ["walletHistoryDialog","walletHistory"],
  methods: {
    close() {
      this.$emit("closeHistory");
    },
  },
};
</script>